

















































































import {MixinScreenSize} from '@/components/mixins/MixinScreenSize'
import {Component, Prop, Watch} from 'vue-property-decorator'

@Component
export default class SwapSettingsCard extends MixinScreenSize {
  @Prop({type: Number, required: true})
  allowedSlippageInPercentage!: number

  computedAllowedSlippageInPercentage = String(this.allowedSlippageInPercentage)

  get isMinimumAllowedSlippage() {
    return this.allowedSlippageInPercentage === 0
  }

  handleDecreaseAllowedSlippage() {
    if (this.isMinimumAllowedSlippage) return

    this.$emit(
      'update:allowedSlippageInPercentage',
      parseFloat((this.allowedSlippageInPercentage - 0.1).toFixed(1))
    )
  }

  handleIncreaseAllowedSlippage() {
    this.$emit(
      'update:allowedSlippageInPercentage',
      parseFloat((this.allowedSlippageInPercentage + 0.1).toFixed(1))
    )
  }

  @Watch('allowedSlippageInPercentage')
  onAllowedSlippageInPercentageChange() {
    this.computedAllowedSlippageInPercentage = String(
      this.allowedSlippageInPercentage
    )
  }
}
